import { Box } from "@mui/material";
import Typography from "components/basic/typography";
import { PolicySection as PolicySectionData } from "../../content";

/**
 * The id is the anchor the contents list links to, so scroll-margin keeps the
 * heading clear of the fixed site header when jumped to.
 */
const PolicySection: React.FC<{ section: PolicySectionData }> = ({
  section,
}) => (
  <Box
    component="section"
    id={section.id}
    sx={{ marginBottom: 5, scrollMarginTop: "96px" }}
  >
    <Typography
      variant="h5"
      style={{ fontWeight: 700 }}
      sx={{ marginBottom: 2 }}
    >
      {section.title}
    </Typography>

    {section.body}
  </Box>
);

export default PolicySection;
